import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useSupportGroupGetters } from '../../hooks/useSupportGroupGetters.hook';
import joinClassName from '../../utils/className.utils';
import { autoPluralize } from '../../utils/string.utils';
import './SupportGroupJoinedCountDisplay.scss';
var SupportGroupJoinedCountDisplay = function (props) {
    var sg = useSupportGroupGetters(props.supportGroup);
    return React.createElement(Observer, { children: function () { return (React.createElement("span", { className: joinClassName('SupportGroupJoinedCountDisplay', sg.numJoined === 0 && 'empty', !!sg.isFull && 'full', !!sg.almostFull && 'almostFull') }, props.supportGroup ? (props.showActualCount ? React.createElement(React.Fragment, null,
            React.createElement("span", null,
                sg.numJoined,
                " / ",
                sg.max),
            sg.isFull && React.createElement("em", null, " (Full)")) : React.createElement(React.Fragment, null,
            sg.almostFull && React.createElement("em", null,
                autoPluralize(sg.numAvailable, 'spot'),
                " left"),
            sg.isFull && React.createElement("em", null, "Fully booked"))) : '')); } });
};
export default SupportGroupJoinedCountDisplay;
